import React from 'react';
import PropTypes from 'prop-types';
import { CompanyDataDiv, SectionBox } from './CompanyHome.styles';

const CompanyData = ({ c, address }) => (
  <CompanyDataDiv>
    <SectionBox>
      <h4>Company Details</h4>
      <div>
        {c?.phoneOffice && (
          <p>
            <strong>Phone Office:</strong> {c.phoneOffice}
          </p>
        )}
        {c?.website && (
          <p>
            <strong>Website:</strong> {c.website}
          </p>
        )}
        {c?.createdAt && (
          <p>
            <strong>Created At:</strong>{' '}
            {new Date(c.createdAt).toLocaleDateString()}
          </p>
        )}
        {c?.updatedAt && (
          <p>
            <strong>Updated At:</strong>{' '}
            {new Date(c.updatedAt).toLocaleDateString()}
          </p>
        )}
        {c?.active !== undefined && (
          <p>
            <strong>Active:</strong>{' '}
            {c.active ? 'Company is active' : 'Company is not active'}
          </p>
        )}
        {c?.industry && (
          <p>
            <strong>Industry:</strong> {c.industry}
          </p>
        )}
        {c?.notes && (
          <p>
            <strong>About Company:</strong> {c.notes}
          </p>
        )}
      </div>
    </SectionBox>
    {c?.mainContact && (
      <SectionBox>
        <h4>Primary Contact</h4>
        <div>
          {c?.mainContact && (
            <p>
              <strong>Main Contact:</strong> {c.mainContact}
            </p>
          )}
          {c?.email && (
            <p>
              <strong>Email:</strong> {c.email}
            </p>
          )}
          {c?.phoneMobile && (
            <p>
              <strong>Phone Number:</strong> {c.phoneMobile}
            </p>
          )}
        </div>
      </SectionBox>
    )}

    {c?.secondaryContact && (
      <SectionBox>
        <h4>Secondary Contact</h4>
        <div>
          {c?.secondaryContact && (
            <p>
              <strong>Secondary Contact:</strong> {c.secondaryContact}
            </p>
          )}
          {c?.secondaryEmail && (
            <p>
              <strong>Secondary Email:</strong> {c.secondaryEmail}
            </p>
          )}
        </div>
      </SectionBox>
    )}
    <SectionBox>
      <h4>Address</h4>
      <div>
        {address?.street && (
          <p>
            <strong>Street:</strong> {address.street}
          </p>
        )}
        {address?.city && (
          <p>
            <strong>City:</strong> {address.city}
          </p>
        )}
        {address?.province && (
          <p>
            <strong>Province:</strong> {address.province}
          </p>
        )}
        {address?.postalCode && (
          <p>
            <strong>Postal Code:</strong> {address.postalCode}
          </p>
        )}
      </div>
    </SectionBox>
  </CompanyDataDiv>
);

CompanyData.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    postalCode: PropTypes.string,
    province: PropTypes.string,
  }),
  c: PropTypes.shape({
    industry: PropTypes.string,
    logo: PropTypes.string,
    phoneOffice: PropTypes.string,
    website: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    active: PropTypes.bool,
    notes: PropTypes.string,
    mainContact: PropTypes.string,
    email: PropTypes.string,
    phoneMobile: PropTypes.string,
    secondaryContact: PropTypes.string,
    secondaryEmail: PropTypes.string,
  }),
};

export default CompanyData;
